import { Loader } from '@googlemaps/js-api-loader';
export default class LocationMap {
    mapElement;
    map;
    salesLocation;
    serviceLocation;
    markers = [];
    locations;
    initialLoad;
    constructor() {
        this.mapElement = document.querySelector('.js-locationmap');
        if (!this.mapElement)
            return;
        const url = this.mapElement.dataset.locationjson;
        this.initialLoad = true;
        fetch(url)
            .then((response) => {
            if (response.ok) {
                return response.json();
            }
            else {
                throw new Error('Failed to fetch location data.');
            }
        })
            .then((data) => {
            this.locations = data.result.map((location) => {
                const address = {
                    city: location.address.city,
                    houseNumber: location.address.houseNumber,
                    postalCode: location.address.postalCode,
                    street: location.address.street,
                };
                let salesLocationBoolean = false, serviceLocationBoolean = false;
                location.services.forEach((item) => {
                    if (item.includes('Occasions') || item.includes("Nieuwe auto's")) {
                        salesLocationBoolean = true;
                    }
                    if (item.includes('Service') || item.includes('Schadeherstel')) {
                        serviceLocationBoolean = true;
                    }
                });
                return {
                    title: location.title,
                    lat: parseFloat(location.location.lat),
                    lng: parseFloat(location.location.lng),
                    phoneNumber: location.phoneNumber,
                    phoneNumberLink: location.phoneNumberLink,
                    websiteUrl: location.websiteUrl,
                    address: address,
                    slug: location.slug,
                    services: location.services,
                    salesLocation: salesLocationBoolean,
                    serviceLocation: serviceLocationBoolean,
                };
            });
            this.initMap(this.locations);
        })
            .catch((error) => {
            console.error(error);
        });
    }
    createInfoWindowContent(location) {
        const { title, address, phoneNumberLink, phoneNumber, websiteUrl, slug, salesLocation, serviceLocation, } = location;
        const detailLink = this.mapElement.dataset.establishmentdetaillink;
        const addressLine = address
            ? `${address.street} ${address.houseNumber}<br/> ${address.postalCode} ${address.city}`
            : '';
        const addressHTML = addressLine ? `<p>${addressLine}</p>` : '';
        const phoneNumberHTML = phoneNumberLink && phoneNumber
            ? `<p><a href="tel:${phoneNumberLink}">${phoneNumber}</a></p>`
            : '';
        const websiteHTML = websiteUrl
            ? `<p><a href="${websiteUrl}" target="_blank">Bekijk website</a></p>`
            : '';
        const deatailLink = slug
            ? `<a href="${detailLink}${slug}" class="location--detail-link" title="detail-page-${title}" alt="detail-page-${title}">
                <svg xmlns="http://www.w3.org/2000/svg" class="arrow-svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
            </a>`
            : '';
        const salePill = salesLocation ? `<div class="pill">Verkoop</div>` : '';
        const servicePill = serviceLocation ? `<div class="pill">Service</div>` : '';
        const pillBox = salesLocation || serviceLocation
            ? `<div class="pillbox">${salePill}${servicePill}</div>`
            : '';
        return `<div class="locationmap--infowindow">
                    <h2 class='h6'>${title}</h2>
                    ${pillBox}
                    ${addressHTML}
                    ${phoneNumberHTML}
                    ${websiteHTML}
                    ${deatailLink}
                </div>`;
    }
    initMap(locations) {
        const loader = new Loader({
            apiKey: 'AIzaSyCaepW3BNZRTT0SCBhBrH_4Yo16c-rlJ_s',
            libraries: ['marker'],
        });
        loader
            .load()
            .then(async () => {
            const { Map } = (await google.maps.importLibrary('maps'));
            this.map = new Map(this.mapElement, {
                zoom: 10,
                mapId: '646cebdc8f46160e',
                center: { lat: -34.397, lng: 150.644 },
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });
            let values = [];
            this.setLocationMarkers(values);
        })
            .catch((error) => {
            console.error(error);
        });
    }
    removeMarkers() {
        this.markers.forEach((marker) => {
            marker.map = null;
        });
        this.markers = []; // Clear the markers array
    }
    setLocationMarkers(values) {
        const bounds = new google.maps.LatLngBounds();
        const infowindow = new google.maps.InfoWindow();
        let filteredResults = [];
        if (values[values.length - 1]) {
            if (values == 'sale') {
                filteredResults = this.locations.filter((location) => {
                    return location.salesLocation === true;
                });
            }
            else if (values == 'service') {
                filteredResults = this.locations.filter((location) => {
                    return location.serviceLocation === true;
                });
            }
            else {
                filteredResults = this.locations.filter((location) => {
                    return location.salesLocation === true || location.serviceLocation === true;
                });
            }
        }
        else {
            filteredResults = this.locations;
        }
        this.removeMarkers();
        filteredResults.forEach((location) => {
            const markerImg = document.createElement('img');
            markerImg.src = this.mapElement.dataset.locationmarker;
            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: new google.maps.LatLng(location.lat, location.lng),
                map: this.map,
                content: markerImg,
            });
            bounds.extend(marker.position);
            marker.addListener('click', () => {
                const infowindowContent = this.createInfoWindowContent(location);
                infowindow.setContent(infowindowContent);
                infowindow.open(this.map, marker);
            });
            this.markers.push(marker); // Store the created marker
        });
        if (this.initialLoad) {
            this.map.fitBounds(bounds);
            this.initialLoad = false;
        }
    }
}
